import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectLinktree } from "../redux/selectors";
import {
  setSmartMenu,
  fetchLinktree,
  deleteLinktreeLink, 
  sortLinktreeLinks, 
  updateLinktree,
  updateLinktreeLink
} from "../redux/actions";
import {
  delete_linktree,
} from "../utils/requestHelper";
import { useNavigate } from "react-router-dom";
import { LinktreeView } from "../components";
import { getLinktreeUpdatePayload } from "../utils/linktreeHelper";
import { useModal } from "../hooks/useModal";
import NewLinktreeLink from "../components/modal/newLinktreeLink";

const Linktree = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const linktree = useSelector(selectLinktree);
  const { show: showA, hide: hideA, RenderModal: RenderModalA } = useModal();

  useEffect(() => {
    const { id } = params;
    if (id)
      dispatch(fetchLinktree(id));
  }, [params]);

  useEffect(() => {
    if (linktree)
      dispatch(
        setSmartMenu({
          headline: `${linktree.title}`,
          buttons: [{ key: 'add_linktreeLink', name: 'button-add_linktreeLink', icon: 'add', onButtonClick: ()=>showA(true)} ],
          navigation: null,
        }),
      );
  }, [linktree]);

  const handleOnClickDelete = async (target) => {
    const { id } = target;
    var result = await delete_linktree(id);
    if (result.success === true) {
      navigate(`/linktrees`);
    }
  };

  const handleOnClickCancel = async () => {
    navigate(`/linktrees`);
  };

  const handleOnClickSubmit = async (target) => {
    const { id, data } = target;
    const payload = getLinktreeUpdatePayload(data);
    dispatch(updateLinktree(id, payload));
    navigate(`/linktrees`);
  };

  const handleOnCLickSortLinks = async (links) => {
    dispatch(sortLinktreeLinks(linktree.id, links));
  }

  const handleOnClickDeleteLink = async (linkId) => {
    dispatch(deleteLinktreeLink(linktree.id, linkId));
  }

  const handleOnToggleActiveLink = async ({ id, isActive }) => {
    const payload = getLinktreeUpdatePayload({isActive: isActive});
    dispatch(updateLinktreeLink(linktree.id, id, payload));
  };

  return (
    <article>
      <LinktreeView
        show={ linktree !== undefined && linktree !== null }
        data={linktree}
        onClickDelete={handleOnClickDelete}
        onClickCancel={handleOnClickCancel}
        onClickSubmit={handleOnClickSubmit}
        onSortLinks={handleOnCLickSortLinks}
        onClickDeleteLinks={handleOnClickDeleteLink}
        onToggleActiveLink={handleOnToggleActiveLink}
      />
      <RenderModalA>
        <NewLinktreeLink
          hide={hideA}
          parentId={linktree ? linktree.id : null}
        />
      </RenderModalA>
    </article>
  );
};

export default Linktree;
